import React from "react";
import PropTypes from "prop-types";
import BootstrapModal from "../BootstrapModal";
import { useDispatch } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";
import withModal from "../withModal";

const UpdateDefaultMinSingleViewCountModal = ({ modalProps, isOpen }) => {
    const dispatch = useDispatch();

    const hide = () => dispatch(hideModal("UPDATE_MIN_SINGLEVIEW_COUNT"));

    const save = updateAll => modalProps.handleUpdate(updateAll);

    const renderFooter = () => (
        <div>
            <button className="btn btn-primary" onClick={() => save(false)}>
                Update Default Value Only
            </button>
            <button className="btn btn-success" onClick={() => save(true)}>
                Update All
            </button>
            <button className="btn btn-default" onClick={() => hide()}>
                Cancel
            </button>
        </div>
    );

    return (
        <BootstrapModal
            isOpen={isOpen}
            title="Update Default Minimum Single View Count"
            primaryButtonText="Update"
            closeButtonText="Cancel"
            onRequestClose={hide}
            onRequestPrimary={save}
            footer={renderFooter()}
        >
            <p>
                Update default value will only update the default for future advertisers enabled
                <br />
                <br />
                Update all will save the default value and save the minimum for all currently enabled advertisers
                <br />
                <br />
            </p>
        </BootstrapModal>
    );
};

UpdateDefaultMinSingleViewCountModal.propTypes = {
    modalProps: PropTypes.any,
    isOpen: PropTypes.bool,
    // Injected from Redux (ActionCreators)
    hideModal: PropTypes.func,
};

export default withModal(UpdateDefaultMinSingleViewCountModal, "UPDATE_MIN_SINGLEVIEW_COUNT");
